import React from 'react';

const FormSwitcher = ({ id }) => {
  return <input type="checkbox" class={id || "form-switcher"} id={id || "form-switcher"} />;
};

export default FormSwitcher;